import { useTranslation } from '@lyearn/i18n';
import { AlertDialog } from '@lyearn/molecules';

import { SubmitQuizDialogProps } from './types';

const SubmitQuizDialog: React.FC<SubmitQuizDialogProps> = (props) => {
  const { count, onClose, onSubmitQuiz, dialogType } = props;
  const { t } = useTranslation();

  if (dialogType === 'confirmation') {
    return (
      <AlertDialog
        header={{
          title: t('QuizPlayer:SubmitQuizDialogTitle'),
          description: t('QuizPlayer:SubmitQuizConfirmationDescription'),
        }}
        primaryAction={{
          label: t('Common:Actions.Submit'),
          onClick: onSubmitQuiz,
        }}
        secondaryAction={{
          label: t('Common:Actions.GoBack'),
        }}
        onClose={onClose}
      />
    );
  }

  if (dialogType === 'unanswered') {
    return (
      <AlertDialog
        header={{
          title: t('QuizPlayer:SubmitQuizDialogTitle'),
          description: t('QuizPlayer:SubmitQuizDialogDescription', {
            count,
          }),
        }}
        primaryAction={{
          label: t('Common:Actions.Submit'),
          onClick: onSubmitQuiz,
        }}
        secondaryAction={{
          label: t('Common:Actions.GoBack'),
        }}
        onClose={onClose}
      />
    );
  }

  return null;
};

export default SubmitQuizDialog;
